import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector } from '@angular/core';
import { InjectorService } from './services/injector.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SocketIoModule } from 'ngx-socket-io';
import { AppMaterialModule } from './app-material.module';
import { ServicesModule } from './services/services.module';
import { InformationviewComponent } from './components/informationview/informationview.component';
import { FooterbarComponent } from './components/footerbar/footerbar.component';
import { WidgetModule } from './components/widgets/widget.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigLoaderModule } from './config/configloader.module';
import { PySyncSocketModule } from './pySyncSocket.module';
import { TaskboardViewComponent } from './actionviews/taskboard-view/taskboard-view.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { IssuecardComponent } from './components/issuecard/issuecard.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { CreateUserstoryDialogComponent } from './components/create-userstory-dialog/create-userstory-dialog.component';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CreateSprintErrorMessageComponent } from './components/create-sprint-error-message/create-sprint-error-message.component';
import { ConfirmationDialogComponent } from './components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { MpcBoardViewComponent } from './actionviews/mpc-board-view/mpc-board-view.component';
import { PopupDodComponent } from './components/popup-dod/popup-dod.component';
import { ReleasePlanningViewComponent } from './actionviews/release-planning-view/release-planning-view.component';
import { IssueComponent } from './components/issue/issue.component';
import { LoginViewComponent } from './actionviews/login-view/login-view.component';
import { UserlistComponent } from './components/userlist/userlist.component';
// eslint-disable-next-line max-len
import { DeleteSprintConfirmationdialogComponent } from './components/sprint-dialog/delete-sprint-confirmationdialog/delete-sprint-confirmationdialog.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// eslint-disable-next-line max-len
import { CreateProgramIncrementDialogComponent } from './components/create-program-increment-dialog/create-program-increment-dialog.component';
import { MpcBoardTeamComponent } from './components/mpc-board/mpc-board-team/mpc-board-team.component';
import { MpcBoardSprint } from './components/mpc-board/mpc-board-sprint/mpc-board-sprint.component';
import { KanbanBoardViewComponent } from './actionviews/kanban-board-view/kanban-board-view.component';
import { KanbanBacklogComponent } from './components/kanban/backlog/backlog.component';
import { KanbanGridNoswimlaneComponent } from './components/kanban/grids/kanban-grid-noswimlane/kanban-grid-noswimlane.component';
import { KanbanBoardDirective } from './actionviews/kanban-board-view/kanban-board.directive';
import { TaskcardDetailComponent } from './components/kanban/taskcard-detail/taskcard-detail.component';
import { StickerDetailComponent } from './components/sticker-detail/sticker-detail.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { KanbanGridDefaultComponent } from './components/kanban/grids/kanban-grid-default/kanban-grid-default.component';
import { AcknowledgeDialogComponent } from './components/dialogs/acknowledge-dialog/acknowledge-dialog.component';
import { CreateProgramDialogComponent } from './components/create-program-dialog/create-program-dialog.component';
import { Sprintplanning2ViewComponent } from './actionviews/sprintplanning2-view/sprintplanning2-view.component';
import { Sp2DragPreviewComponent } from './components/sprintplanning2/sp2-drag-preview/sp2-drag-preview.component';
import { BrandingHeaderbar } from './components/branding-header-bar/branding-header-bar.component';
import { ReleaseplanningSprintColumn } from
  './components/releaseplanning/releaseplanning-sprint-column/releaseplanning-sprint-column.component';
import { KanbanTaskcardComponent } from './components/kanban/taskcard/taskcard.component';
import { ProductBacklogComponent } from './components/product-backlog/product-backlog.component';
import { SprintcardComponent } from './components/sprintcard/sprintcard.component';
import { NgOptimizedImage } from '@angular/common';
import { ToolbarModule } from './components/toolbar/toolbar.module';
import { AssetIconModule } from './components/asset-icon/asset-icon.module';
import { DirectivesModule } from './directives/directives.module';
import { OnlineStateComponent } from './components/online-state/online-state.component';
import { httpinterceptorModule } from './httpinterceptorModule/httpinterceptor';
import { UserprofiledialogComponent } from './components/dialogs/userprofildialog/userprofiledialog.component';
import { LastUpdatedComponent } from './components/last-updated/last-updated.component';
import { UnseenIndicatorComponent } from './components/unseen-indicator/unseen-indicator.component';
import { PipesModule } from './pipes/pipes.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const notifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: false,
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
  AppComponent,
  FooterbarComponent,
  BrandingHeaderbar,
  InformationviewComponent,
  IssuecardComponent,
  SprintcardComponent,
  IssueComponent,
  TaskboardViewComponent,
  CreateUserstoryDialogComponent,
  CreateProgramIncrementDialogComponent,
  CreateSprintErrorMessageComponent,
  ConfirmationDialogComponent,
  AcknowledgeDialogComponent,
  PopupDodComponent,
  MpcBoardViewComponent,
  ReleasePlanningViewComponent,
  DeleteSprintConfirmationdialogComponent,
  MpcBoardTeamComponent,
  MpcBoardSprint,
  ReleaseplanningSprintColumn,
  KanbanBoardViewComponent,
  KanbanBacklogComponent,
  KanbanTaskcardComponent,
  KanbanGridDefaultComponent,
  KanbanGridNoswimlaneComponent,
  KanbanBoardDirective,
  TaskcardDetailComponent,
  StickerDetailComponent,
  CreateProgramDialogComponent,
  Sprintplanning2ViewComponent,
  Sp2DragPreviewComponent,
  ProductBacklogComponent,
  OnlineStateComponent,
  LoginViewComponent,
  UserprofiledialogComponent,
  UserlistComponent,
  LastUpdatedComponent,
  UnseenIndicatorComponent,

  ],
  imports: [
  BrowserModule,
  BrowserAnimationsModule,
  FormsModule,
  ScrollingModule,
  ReactiveFormsModule,
  MatExpansionModule,
  HttpClientModule,
  DragDropModule,
  NgMultiSelectDropDownModule,
  ConfigLoaderModule,
  TranslateModule.forRoot({
    loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient]
    }
    }),
  PySyncSocketModule,
  AppRoutingModule,
  FormsModule,
  AppMaterialModule,
  ServicesModule,
  SocketIoModule,
  WidgetModule,
  NgbModule,
  NotifierModule.withConfig(notifierOptions),
  ColorPickerModule,
  NgOptimizedImage,
  DirectivesModule,
  ToolbarModule,
  AssetIconModule,
  httpinterceptorModule,
  PipesModule
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
  })
export class AppModule {
  constructor(private injector: Injector) {
    InjectorService.injector = this.injector;
  }
}
